import React, { Fragment, Component } from 'react'
import axios from 'axios'
import { getApiBaseUrl } from '../utils/api';
import SiteFooter from '../components/SiteFooter';
import { insurance } from '../content/siteContent';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Insurance extends Component {
    
    constructor(){
        super();
        this.state={
            name: '',
            mobileno: '',
            email:'',
            invpurpose:''
        }
    }

    onChangeInput = (e) => {
        const re = /^[0-9\b]+$/;
        if(e.target.name === "name"){
          this.setState({
              name: e.target.value
          });
        } else if(e.target.name === "mobileno" && (re.test(e.target.value) || e.target.value === "") && e.target.value.length <= 10){
            this.setState({
                mobileno: e.target.value
            });
         } else if(e.target.name === "email"){
             this.setState({
                 email: e.target.value
             });
         } else if(e.target.name === "invpurpose"){
             this.setState({
                invpurpose: e.target.value
             });
         }
    }
    
    onSendMessage = async () => {
        let enquiryDetail = {
            Name: this.state.name,
            MobileNumber: this.state.mobileno,
            EmailId: this.state.email,
            InvestmentPurpose: this.state.invpurpose
        };
        if(enquiryDetail.Name.length == 0 || enquiryDetail.MobileNumber.length == 0 || enquiryDetail.EmailId.length == 0){
            toast.warning("Please enter Name, Mobile Number and EmailId");
            return;
        }
        await axios.post(`${getApiBaseUrl()}/hj-enquiry/createInsuranceEnq`,enquiryDetail)
            .then((res) => {
                toast.success("Insurance Enquiry saved Successfully! Our executive will contact you as soon as possible.");
                this.clearForm();
            }).catch((error) => {
                console.log(error);
            });
    }
    clearForm = async () =>{
        this.setState({
            name: '',
            mobileno: '',
            email:'',
            invpurpose:''
        })
    }
    render(){
        return (
            <Fragment>
                <ToastContainer />
                <div className="boxed_wrapper ltr">
                    {/* Mobile Menu  */}
                    <div className="mobile-menu">
                    <div className="menu-backdrop"></div>
                    <div className="close-btn"><i className="fas fa-times"></i></div>

                    <nav className="menu-box">
                        <div className="nav-logo"><a href="/"><img src="assets/images/logo-4.png" alt="H.J. Enterprises" title=""/></a></div>
                        <div className="menu-outer">{/*Here Menu Will Come Automatically Via Javascript / Same Menu as in Header*/}</div>
                    </nav>
                    </div>{/* End Mobile Menu */}


                    {/* page-title */}
                    <section className="page-title centred">
                    <div className="bg-layer" style={{backgroundImage: "url(assets/images/background/page-title.jpg)"}}></div>
                    <div className="pattern-layer">
                        <div className="pattern-1" style={{backgroundImage: "url(assets/images/shape/shape-18.png)"}}></div>
                        <div className="pattern-2" style={{backgroundImage: "url(assets/images/shape/shape-17.png)"}}></div>
                    </div>
                    <div className="auto-container">
                        <div className="content-box">
                            <h1>{insurance.title}</h1>
                        </div>
                    </div>
                    </section>
                    {/* page-title end */}

                    {/* career-details */}
                    <section className="career-details pt_50 pb_50">

                        <div className="auto-container">

                            <div className="row clearfix">
                            <div className="col-lg-12 col-md-12 col-sm-12 content-side">
                                <div className="career-details-content">
                                    <div className="content-one mb_50">
                                        <h2>{insurance.subtitle}</h2>
                                        <p>{insurance.intro}</p>
                                        <p>{insurance.assist}</p>
                                        <ul>
                                            {insurance.products.map((item) => <li key={item}>{item}</li>)}
                                        </ul>
                                        <p>{insurance.objective}</p>
                                    </div>

                                </div>
                            </div>

                            </div>
                        </div>
                    </section>
                    {/* career-details end */}

                    {/* faq-form-section */}
                    <section className="faq-form-section pt_50 pb_120">
                        <div className="auto-container" id="register-form-insurance">
                            <div className="sec-title mb_70 centred">
                                <h2>Register Form</h2>
                            </div>
                            <div className="form-inner">
                                <div className="row clearfix">
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="name" 
                                            placeholder="Your Full Name" 
                                            required=""
                                            onChange={this.onChangeInput}
                                            value={this.state.name}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="mobileno" 
                                            placeholder="Mobile Number" 
                                            required=""
                                            onChange={this.onChangeInput}
                                            value={this.state.mobileno}
                                        />
                                    </div>
                                    <div className="col-lg-6 col-md-6 col-sm-12 form-group">
                                        <input 
                                            type="email" 
                                            name="email" 
                                            placeholder="Your Email" 
                                            required=""
                                            onChange={this.onChangeInput}
                                            value={this.state.email}
                                        />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group">
                                        <input 
                                            type="text" 
                                            name="invpurpose" 
                                            placeholder="Insurance requirement"
                                            onChange={this.onChangeInput}
                                            value={this.state.invpurpose}
                                        />
                                    </div>
                                    <div className="col-lg-12 col-md-12 col-sm-12 form-group message-btn centred">
                                        <button type="submit" className="theme-btn btn-one" onClick={this.onSendMessage}>Send Message</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* faq-form-section end */}

                    {/* main-footer */}
                    <SiteFooter />
                    {/* main-footer end */}

                    {/*Scroll to top*/}
                    <div className="scroll-to-top">
                        <div>
                            <div className="scroll-top-inner">
                                <div className="scroll-bar">
                                    <div className="bar-inner"></div>
                                </div>
                                <div className="scroll-bar-text">Go To Top</div>
                            </div>
                        </div>
                    </div>
                    {/* Scroll to top end */}

                </div>
            </Fragment>
        )
    }
}

export default Insurance;